import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { coordinateInputValidation, getPatterValidationFunc, getRequiredValidationFunc } from "./commons";
import { KButton, KBUTTON_SIZE, KBUTTON_VARIANT } from "./KButton";
import { Translate } from "react-redux-i18n";
import { tooltipate } from "../index";
export var KInputHintVariant;
(function (KInputHintVariant) {
    KInputHintVariant["PRIMARY"] = "primary";
    KInputHintVariant["WARNING"] = "warning";
    KInputHintVariant["DANGER"] = "danger";
    KInputHintVariant["DEFAULT"] = "default";
})(KInputHintVariant || (KInputHintVariant = {}));
export const KInput = ({ copyButton = false, id, name, label, validate, pattern, defaultValue, value, required, errorMessage, as, type, disabled, placeholder, readOnly, onChange, dark = false, onClick, hint, hintVariant = KInputHintVariant.DEFAULT, addedTextAreaHeight = 0, tooltip, forceErrorMessageBellow, }) => {
    const [copied, setCopied] = useState(false);
    const [errorMsg, setErrorMsg] = useState(required ? (errorMessage instanceof Map ? errorMessage.get("required") : errorMessage) : undefined);
    const [showErrorBellow, setShowErrorBellow] = useState(forceErrorMessageBellow === true || (forceErrorMessageBellow instanceof Map && !!forceErrorMessageBellow.get("required")));
    return (_jsxs(Form.Group, { controlId: id, className: "k-input-group", onClick: onClick, children: [_jsx(Form.Control, { as: as, name: name || id, type: type, required: required, disabled: disabled, readOnly: readOnly, onChange: (e) => {
                    const errorKeys = [];
                    coordinateInputValidation([validate, getPatterValidationFunc(pattern)], id, errorKeys, getRequiredValidationFunc(required));
                    if (errorMessage instanceof Map) {
                        const msg = errorKeys.map((ek) => errorMessage.get(ek)).filter((m) => !!m)[0];
                        setErrorMsg(msg);
                    }
                    else {
                        setErrorMsg(errorMessage);
                    }
                    if (forceErrorMessageBellow instanceof Map) {
                        setShowErrorBellow(errorKeys.map((ek) => !!forceErrorMessageBellow.get(ek))[0]);
                    }
                    if (onChange) {
                        onChange(e);
                    }
                }, placeholder: placeholder, defaultValue: defaultValue, value: value, className: `k-input ${label ? "" : "no-label"} ${dark ? "darkmode" : ""}`, style: { height: 40 + (as === "textarea" ? addedTextAreaHeight : 0) } }), hint ? _jsx("div", { className: `k-hint k-hint-variant-${hintVariant}`, children: hint }) : null, copyButton && !disabled ? (_jsx(KButton, { text: _jsxs(_Fragment, { children: [_jsx("i", { className: "fal fa-copy" }), " ", _jsx(Translate, { value: copied ? "input.copied" : "input.copy" })] }), size: KBUTTON_SIZE.xs, variant: KBUTTON_VARIANT.link, style: {
                    position: "absolute",
                    right: 0,
                    top: label ? 33 : 4,
                    textDecoration: "none",
                    color: copied ? "#2bd18f" : "#5198f4",
                    backgroundColor: dark ? "#585f6c" : "#f6f6f7",
                    borderBottom: "#fff",
                }, onClick: () => {
                    const copyText = document.getElementById(id);
                    if (copyText) {
                        copyText.select();
                        copyText.setSelectionRange(0, 99999); /* For mobile devices */
                        /* Copy the text inside the text field */
                        document.execCommand("copy");
                        setCopied(true);
                        setTimeout(() => {
                            setCopied(false);
                        }, 5000);
                    }
                } })) : null, label ? (_jsxs("div", { className: "label-holder", children: [tooltipate(_jsx(Form.Label, { className: `k-input-label${required ? " required" : ""}${dark ? " darkmode" : ""}`, children: label }), tooltip, undefined, true), errorMsg && !showErrorBellow ? (_jsx(Form.Control.Feedback, { as: "span", type: "invalid", children: errorMsg })) : null] })) : errorMsg ? (_jsx(Form.Control.Feedback, { as: "span", type: "invalid", children: errorMsg })) : null, showErrorBellow && errorMsg && label ? (_jsx(Form.Control.Feedback, { as: "span", type: "invalid", children: errorMsg })) : null] }));
};
